var map = {
	"./account.svg": 4307,
	"./address.svg": 4186,
	"./arrow-bg.svg": 7663,
	"./arrow-white.svg": 4637,
	"./arrow.svg": 6441,
	"./basket.svg": 3452,
	"./chevron-right-white.svg": 5150,
	"./droparrow.svg": 3008,
	"./facebook.svg": 8006,
	"./footer-logo.svg": 281,
	"./footer-plane.svg": 4418,
	"./home.svg": 4707,
	"./instagram.svg": 5314,
	"./logo.svg": 7139,
	"./logout.svg": 512,
	"./menu-bg.png": 3674,
	"./menu-icon copy.svg": 6402,
	"./menu-icon.svg": 8119,
	"./orders.svg": 6325,
	"./paper-tear.svg": 4797,
	"./parcel.svg": 2205,
	"./patterns/chevrons.png": 8525,
	"./patterns/circles.png": 9138,
	"./patterns/diamonds-1.png": 8376,
	"./patterns/diamonds-2.png": 5235,
	"./patterns/fans.png": 563,
	"./patterns/geometric.png": 7718,
	"./patterns/leaves-1.png": 2779,
	"./patterns/leaves-2 copy.png": 6597,
	"./patterns/leaves-2.png": 7744,
	"./patterns/linear-diamonds.png": 8330,
	"./patterns/linear-dots.png": 6601,
	"./patterns/ornate.png": 6816,
	"./patterns/rustic-triangles.png": 3035,
	"./patterns/teal-paper.png": 570,
	"./patterns/triangles.png": 8314,
	"./patterns/waves.png": 2123,
	"./payment.svg": 3636,
	"./pinterest.svg": 7976,
	"./rice-two.png": 6839,
	"./secure.svg": 153,
	"./small-underline.png": 2387,
	"./subscription.svg": 4809,
	"./tick.svg": 7905,
	"./twitter.svg": 547,
	"./welcome.jpg": 2977,
	"./xmark-solid.svg": 1287,
	"./xmark-white.svg": 4021,
	"./youtube.svg": 3897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6196;